import React, { useState, useContext, useEffect, useMemo } from "react";

import { FormControlLabel, Grid, Switch } from "@material-ui/core";

import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import Tabs from "../../../../components/tabs/TabsErp";

import TabEmissaoFormaPagto from "./TabEmissaoFormaPagto";
import TabEmissaoTransportadora from "./TabEmissaoTransportadora";
import TabEmissaoObservacoes from "./TabEmissaoObservacoes";

import { Header, Body } from "../styles/Emissao";
import TabEmissaoDocumentos from "./TabEmissaoDocumentos";
import TabEmissaoDI from "./TabEmissaoDI";
import TabEmissaoExportacao from "./TabEmissaoExportacao";
import TabEmissaoAutorizadosXml from "./TabEmissaoAutorizadosXml";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { GlobalVariables } from "../../../../GlobalVariables";
import useEmissaoController from "../controllers/EmissaoController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import TabNFEComplementada from "./TabNFEComplementada";

const AccordionEmissaoSecundarios = ({ ...props }) => {
  const {
    headerTypeNfe,
    headerOperation,
    nfeError,
    setObsText,
    obsTextCreditRate,
    setObsTextCreditRate,
    obsTextCFOP,
    setObsTextCFOP,
    setObsTextComplemento,
    headerCfop,
    nfeListCfop,
    itensTable,
    obsBd,
    nfeId,
    sender,
    mainLoading,
    setConsideraObsCredit,
    saleFinanceSwitch,
    headerFinnally,
    headerModel,
  } = useContext(EmissaoContext);

  const finalities = {
    nfeNormal: 1,
    nfeComplementar: 2,
    nfeAjuste: 3,
    nfDevolucaoMercadoria: 4,
  };
  const { handleCreditRate, handleChangeSaleFinanceSwitch } =
    useEmissaoController();
  const { queryParams } = useContext(QueryParamsContext);

  // O intuito desse useEffect é montar o campo de observação de acordo
  // com os diferentes CFOPs presentes, tanto na header da nota, quanto
  // nos produtos, porém, sem repeti-los.
  // Tratando também sobre o crédito do ICMS, caso aja apresentar obs de tal
  useEffect(() => {
    if (mainLoading) {
      return;
    }

    const currentCfop = nfeListCfop.find((e) => e.cfop === headerCfop);

    let cfopIdsArray = [];
    if (currentCfop) cfopIdsArray.push(currentCfop.id);
    itensTable.forEach((element) => {
      if (element.prodCfopItemList?.id)
        cfopIdsArray.push(element.prodCfopItemList.id);
    });

    let newObsTextCfop = "";
    if (!nfeId) {
      // Modo de fazer um array_unique no JS.
      const unique = [...new Set(cfopIdsArray)];

      unique.forEach((element) => {
        let allCfopObs = nfeListCfop.find((e) => e.id === element);

        if (allCfopObs) {
          if (allCfopObs.observacao)
            newObsTextCfop += `${allCfopObs.observacao?.trim()}\n`;

          if (allCfopObs.cfop_observacoes?.observacao)
            newObsTextCfop += `${allCfopObs.cfop_observacoes?.observacao?.trim()}\n`;
        }
      });

      if (newObsTextCfop) {
        setObsTextCFOP(newObsTextCfop.replace(/\n/g, " "));
      }
    }

    newObsTextCfop = newObsTextCfop ? newObsTextCfop : obsTextCFOP || "";

    /**
     * prouser.empresas
     * coluna crt
     * 1 = Simples Nacional
     * 2 = Simples Nacional, excesso sublimite de receita bruta
     * 3 = Regime Normal
     * 4 = Simples Nacional - Microempreendedor Individual MEI
     */
    const regimeTributarioEmpresa = queryParams.crt;
    let creditRate = "";
    if (regimeTributarioEmpresa === "1" || regimeTributarioEmpresa === "4") {
      creditRate = handleCreditRate(itensTable);
      setConsideraObsCredit(obsTextCreditRate || creditRate);

      if (!nfeId) {
        setObsTextCreditRate(creditRate.replace(/\n/g, ""));
      }
    }

    let arrayText = [];
    let obsChainAll = "";

    if (obsBd) {
      if (nfeId) {
        arrayText = obsBd.split("\n");

        let creditRateExists = arrayText.filter((item) => {
          return creditRate.includes(item);
        });

        let cfopExists = arrayText.filter((item) => {
          return newObsTextCfop.includes(item);
        });

        if (creditRateExists.length === 0 && regimeTributarioEmpresa) {
          obsChainAll += `${obsTextCreditRate}`;
        }
        if (cfopExists.length === 0) {
          obsChainAll += `${newObsTextCfop ? newObsTextCfop : obsTextCFOP}`;
        }
      } else {
        if (regimeTributarioEmpresa) obsChainAll += obsTextCreditRate;
        obsChainAll += `\n${newObsTextCfop ? newObsTextCfop : obsTextCFOP}`;
      }
    }

    newObsTextCfop = `\n ${obsBd}`;
    let obsChainComplemento =
      arrayText.length !== 0 ? arrayText.join("\n") : newObsTextCfop;
    obsChainAll += obsChainComplemento;

    if (!obsChainComplemento) setObsTextComplemento(obsChainComplemento);
    setObsText(obsChainAll);
    // eslint-disable-next-line
  }, [
    headerCfop,
    setObsText,
    setObsTextCreditRate,
    setObsTextCFOP,
    setObsTextComplemento,
    nfeListCfop,
    itensTable,
    handleCreditRate,
    obsBd,
    nfeId,
    setConsideraObsCredit,
    sender,
    mainLoading,
  ]);

  const [tabIndex, setTabIndex] = useState(0);

  const isModel65 = useMemo(() => headerModel?.value === "65", [headerModel]);

  const tabHeaders = [
    {
      label: "Forma de Pagto",
    },
    {
      label: "Transportadora/Volumes",
    },
    {
      label: "Observações",
    },
    Number(headerFinnally.value) !== finalities.nfeComplementar
      ? {
          label: "Documentos Referenciados",
        }
      : {
          label: "NFe Complementada",
        },
    {
      label: "Autorizados XML",
    },
  ];

  const tabContents = [
    <TabEmissaoFormaPagto key="tab-emissao-forma-pagto" />,
    <TabEmissaoTransportadora key="tab-emissao-transportadora" />,
    <TabEmissaoObservacoes key="tab-emissao-observacoes" />,
    Number(headerFinnally.value) !== finalities.nfeComplementar ? (
      <TabEmissaoDocumentos key="tab-emissao-documentos" />
    ) : (
      <TabNFEComplementada key="tab-nfe-complementada" />
    ),
    <TabEmissaoAutorizadosXml key="tab-emissao-autorizados-xml" />,
  ];

  //Operação com exterior
  if (headerOperation?.value === GlobalVariables.nfe.operations.foreign) {
    //Tipo entrada
    if (headerTypeNfe?.value === GlobalVariables.nfe.types.entry) {
      tabHeaders.push({
        label: "Dados de Importação",
      });
      tabContents.push(<TabEmissaoDI key="tab-emissao-ii" />);
    }

    //Tipo saida
    if (headerTypeNfe?.value === GlobalVariables.nfe.types.exit) {
      tabHeaders.push({
        label: "Dados de Exportação",
      });
      tabContents.push(<TabEmissaoExportacao tab="tab-emissao-exportacao" />);
    }
  }

  return (
    <Fieldset
      titulo={
        <Header>
          <Grid container spacing={2}>
            <Grid
              item
              lg={isModel65 ? 12 : 10}
              sm={isModel65 ? 12 : 10}
              xs={isModel65 ? 12 : 10}
            >
              <Chip
                label="OUTRAS INFORMAÇÕES"
                bgcolor={
                  nfeError.accordions && nfeError.accordions.includes("footer")
                    ? "red"
                    : ""
                }
                textcolor={
                  nfeError.accordions && nfeError.accordions.includes("footer")
                    ? "white"
                    : ""
                }
              />
            </Grid>
            {!isModel65 && (
              <Grid
                item
                lg={2}
                sm={2}
                xs={2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={saleFinanceSwitch}
                      onChange={handleChangeSaleFinanceSwitch}
                      disabled={!saleFinanceSwitch}
                    />
                  }
                  label="Financeiro da Venda"
                />
              </Grid>
            )}

            {/* )} */}
          </Grid>
        </Header>
      }
      bgcolor="white"
      textcolor="black"
      accordion
      defaultExpanded={false}
    >
      <Body>
        <Tabs
          headers={tabHeaders}
          children={tabContents}
          tabIndex={tabIndex}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
        />
      </Body>
    </Fieldset>
  );
};

export default AccordionEmissaoSecundarios;
